/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {ReportTranslationListPageComponent} from './report-translation-list-page.component';

@Component({
  standalone: true,
  imports: [ReportTranslationListPageComponent],
  selector: 'adn-report-translation-route-page',
  template: `
    <adn-report-translation-list-page [readOnly]="readOnly"></adn-report-translation-list-page>
  `
})
export class ReportTranslationRoutePageComponent {
  @Input() readOnly = false;
}
